import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

export const DefaultCell = ({ value }) => (
  <Text size={11} title={value}>
    {value || '-'}
  </Text>
)

DefaultCell.propTypes = {
  value: PropTypes.any,
}
